<template>
  <div class="wf-article-previous-next">
    <div class="container-fluid">
      <div class="wf-article-previous-next-content">
        <div v-if="previousArticle.nodeAliasPath">
          <a class="wf-article-previous" :href="previousArticle.nodeAliasPath">
            <div class="wf-article-previous-next-nav-button">
              <span class="png-icon png-icon-icons-glyph--k-chevron-left">
              </span>
              Prev
            </div>
            <div class="wf-article-previous-next-item">
              <div class="wf-article-previous-next-mobile-caption">
                Previous:
              </div>
              <div class="secondary-heading">
                {{ previousArticle.category }}
              </div>
              <div class="h3 mb-0">
                {{ previousArticle.title }}
              </div>
            </div>
          </a>
        </div>
        <div v-if="nextArticle.nodeAliasPath">
          <a class="wf-article-next" :href="nextArticle.nodeAliasPath">
            <div class="wf-article-previous-next-item">
              <div class="wf-article-previous-next-mobile-caption">
                Next:
              </div>
              <div class="secondary-heading">
                {{ nextArticle.category }}
              </div>
              <div class="h3 mb-0">
                {{ nextArticle.title }}
              </div>
            </div>
            <div class="wf-article-previous-next-nav-button">
              <span
                class="png-icon png-icon-icons-glyph--k-chevron-right"
              ></span>
              Next
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    previousArticle: {
      type: Object
    },
    nextArticle: {
      type: Object
    }
  }
};
</script>
